import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "customValidationError", "dataKey", "help"];
import UIFormControl from 'UIComponents/form/UIFormControl';
import { useInputProps } from '../signup-data/useInputProps';
import { useInputValidation } from '../signup-data/useInputValidation';
import { useSignupData } from '../signup-data/useSignupData';
import { jsx as _jsx } from "react/jsx-runtime";
const FormControl = _ref => {
  let {
      children,
      className = '',
      customValidationError,
      dataKey,
      help
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isInvalid
  } = useSignupData(dataKey);
  const inputProps = useInputProps(dataKey);
  const {
    getValidationText
  } = useInputValidation({
    dataKey,
    customValidationError
  });
  return /*#__PURE__*/_jsx(UIFormControl, Object.assign({
    className: className,
    "data-data-key": dataKey,
    error: isInvalid,
    help: help,
    label: inputProps.label,
    validationMessage: getValidationText()
  }, props, {
    children: children
  }));
};
export default FormControl;